import { isUndefined } from 'lodash-es';

import { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import {
  HOVERED_TILE_OPACITY,
  NOT_HOVERED_TILE_OPACITY,
} from '../constants.js';

export function calculateTileOpacity(
  hovered: LegendItem | undefined,
  value: string,
) {
  return !isUndefined(hovered) &&
    hovered.name.toLowerCase() !== value.toLowerCase()
    ? NOT_HOVERED_TILE_OPACITY
    : HOVERED_TILE_OPACITY;
}
